import { Image, Text } from '@chakra-ui/react';
import { clientEndpoints } from '@texas/clientEndpoints';
import { customersDirectoryStyles } from '@texas/resources/theme/styles/customersDirectory';
import { AngularNavLink } from '../shared/AngularNavLink';

interface CustomerNameCellProps {
  id: number;
  name: string;
  logoIdentifier: string | null;
}

export function CustomerNameCell({
  id,
  name,
  logoIdentifier,
}: CustomerNameCellProps) {
  return (
    <AngularNavLink
      sx={customersDirectoryStyles.name}
      navobj={{ customerId: id }}
      to="customer"
    >
      {logoIdentifier && (
        <Image
          sx={customersDirectoryStyles.logo}
          src={clientEndpoints.previewImage(logoIdentifier, 128)}
          alt=""
          loading="lazy"
        />
      )}
      <Text as="span" sx={customersDirectoryStyles.nameText}>
        {name}
      </Text>
    </AngularNavLink>
  );
}
